import './LeftPanelEOY2025.scss';

import { useEffect } from 'react';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';

import { cxHelpers } from 'util/className';
import {
  EVENT_ACTIONS,
  EVENT_CATEGORIES,
  PRODUCT_AREAS,
  TRACK_ACTION_TYPES,
} from 'util/tracking_constants';
import { useExtendUx, useTrackUx, withUxRoot } from 'util/uxEvents';

const { cx, cxEl } = cxHelpers('LeftPanelEOY2025');

export const LeftPanelEOY2025 = () => {
  const trackUx = useTrackUx();
  const extendUxEvent = useExtendUx();

  extendUxEvent({
    component: 'LeftPanelEOY2025',
  });

  useEffect(() => {
    trackUx(EVENT_ACTIONS.SECTION_VIEWED, TRACK_ACTION_TYPES.VIEW);
  }, [trackUx]);

  return (
    <Box
      className={cx()}
      h="100vh"
      w="100%"
      m="0 auto"
      color="mono0"
      column
      alignItemsBaseline
      justifyContentEnd
    >
      <Box w="45%" ml={32} mb={77} gap={16} column>
        <Box row gap={4} alignItemsCenter>
          <Text
            variant="heading2"
            color="mono0"
            i18n="splash_page.eoy_2025.header_prefix"
          />
          <img
            src={require('./eoy_pay_pill.svg')}
            alt="pay"
            className={cxEl('pay-badge')}
          />
          <Text
            variant="heading2"
            color="mono0"
            i18n="splash_page.eoy_2025.header_suffix"
          />
        </Box>

        <Text i18n="splash_page.eoy_2025.body" asHTML color="mono0" />
      </Box>
    </Box>
  );
};

export default withUxRoot({
  productArea: PRODUCT_AREAS.SIGN_IN,
  eventCategory: EVENT_CATEGORIES.SIGN_IN,
})(LeftPanelEOY2025);
